export default "__VITE_ASSET__Dal5SN2Q__"